<!--
 * @Description: 原物料检测
 * @Author: wangwangwang
 * @Date: 2020-12-01 16:28:55
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-12-29 17:17:43
-->
<template>
  <div class="flows-content">
    <el-container>
      <el-main style="margin-bottom: 20px; padding: 0;">
        <el-container direction="vertical">
          <FlowHeader :isReadOnly="readOnly" @saveSubmit="handleSubmit(1)" @sendSubmit="handleSubmit(2)" @handleBackEnd="handleSubmit(3)" @handleCC="handleSubmit(4)" @handleAssign="handleSubmit(5)" @handleBackUp="handleSubmit(6)" @handleAssist="handleSubmit(7)" @handleNode="handleSubmit(8)" @handleNodeImage="handleSubmit(9)" @handleCollection="handleSubmit(10)" />
          <el-main class="info">
            <div>
              <el-input v-model="title" class="flow-title" :disabled="$route.query.type*1!==1" placeholder="请输入流程标题"></el-input>
            </div>
            <div class="info-top">
              <div class="left">
                <span>单据号码：{{billCode}}</span>
                <span class="text">制单日期：{{billDate}}</span>
              </div>
              <div class="right">
                <span>发起人：{{applyPerson}}</span>
                <span class="text">状态：{{taskTypeText[taskStatus*1]}}</span>
              </div>
            </div>
            <div style="margin-top:20px;">
              <div class="flows-details">
                <el-form :disabled="readOnly" :model="form" label-width="150px">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="系统检测结果">
                        <span>{{$route.query.outcome}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="处理方式">
                        <el-select v-model="form.handling" placeholder="请选择处理方式">
                          <el-option v-if="$route.query.dataTypeId!=3" label="复检" value="1"></el-option>
                          <el-option label="异常处理" value="2"></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item v-show="form.handling==='2'" label="异常现象">
                        <el-input v-model="form.phenomena"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item v-show="form.handling==='2'" label="原因">
                        <el-input v-model="form.cause"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item v-show="form.handling==='2'" label="拟处理方式">
                        <el-radio-group v-model="form.type">
                          <el-radio label="1">退货</el-radio>
                          <el-radio label="2">条件接收</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item v-show="form.handling==='2' && form.type==='2'" label="条件接收方式">
                        <el-select v-model="form.acceptableConditings" placeholder="请选择处理方式">
                          <el-option v-for="item in handleList" :key="item.id" :label="item.name" :value="item.name"></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="供应商">
                        <span>{{formData.supplierName}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="原物料">
                        <span>{{formData.rawName}}</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="车牌号">
                        <span>{{formData.carNo}}</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </div>
              <div>
                <!-- <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width:100%" :data="tableSource" tooltip-effect="dark" height="100%">
                  <template v-for="(item, index) in tableNav">
                    <el-table-column :key="index" :label="item.NAME || item.name" align="center" :width="index == 0 ? '120px' : 'auto'">
                      <template slot-scope="scope">
                        <span v-if="index == 0">{{ scope.row[index].name || scope.row[index].testItem }}</span>
                        <div v-if="index !== 0 && scope.row[index]">
                          <el-select v-if="(scope.row[index].dataType||scope.row[index].type) == 1" v-model="scope.row[index].testValue" placeholder="请选择" style="width:100%" disabled>
                            <el-option v-for="(item, index) in scope.row[index].list" :key="index" :label="item.name" :value="item.name"></el-option>
                          </el-select>
                          <el-input v-else-if="(scope.row[index].dataType||scope.row[index].type) == 2" v-model="scope.row[index].testValue" disabled style="width:100%" placeholder="请输入" clearable></el-input>
                          <span v-else-if="(scope.row[index].dataType||scope.row[index].type) == 3">
                            <span>
                              <el-input v-model="scope.row[index].testValue" disabled type="Number" style="width: 90px;margin-left: 5px;" placeholder="请输入" clearable></el-input>
                            </span>
                          </span>
                          <span v-else><span v-if="scope.row[index].types===3">{{scope.row[index].symbol }} </span>{{scope.row[index].testItem}}</span>
                        </div>
                      </template>
                    </el-table-column>
                  </template>
                </el-table> -->
                <div style="line-height: 40px">异常检验项目</div>
                <el-table :data="tableSource" border style="width: 100%" header-align="center">
                    <el-table-column prop="title" label="检验项目" align="center"></el-table-column>
                    <el-table-column prop="" label="检测值" align="center">
                        <template slot-scope="{row}">
                            <el-select v-if="row.type === 1" v-model="row.resultValue" disabled clearable placeholder="请选择">
                                <el-option v-for="item in row.options" :key="item.id" :label="item.value" :value="item.id"></el-option>
                            </el-select>
                            <el-input v-if="row.type === 2" v-model="row.resultValue" disabled clearable style="width: 215px;" placeholder="请输入" />
                        </template>
                    </el-table-column>
                </el-table>
              </div>
            </div>
            <div class="flows-details">
              <FlowContent ref="flowcontent" :title='title' :showSendVisible="showSendVisible" @handleCancel="handleCancel" @handleBusiness="handleBusiness" @sendCode="sendCode" @handleFinish="handleFinish" @submitData="submitDataType" @resetFlowState="resetFlowState" />
            </div>
          </el-main>
        </el-container>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import FlowContent from '@/components/WorkFlow/flowContent';
import { getOneByPidAndRawId, makeupdStatus } from '@/api/smart/checkout';
import { saveResul } from '@/api/index';
import FlowHeader from '@/components/WorkFlow/flowHeader';
import addTab from "@/common/addTab.js";
import { getUserInfo } from "@/utils/auth.js";
export default {
  components: {
    FlowContent,
    FlowHeader,
  },
  data() {
    return {
      type: 0,
      title: '原物料检测审批',
      billCode: '',
      billDate: '',
      applyPerson: '',
      taskTypeText: ['发起', '已保存', '审批中', '已完成', '撤销', '不通过'],
      taskStatus: 0,
      showSendVisible: false,
      readOnly: false,
      formData: {},
      form: {
        handling: '1',
        type: '1',
      },
      tableSource: [],
      sendTableSource: [],
      tableNav: [],
      handleList: [],
      tableData: [],
    }
  },
  methods: {
    submitDataType() {
      makeupdStatus({
        id: this.formData.id,
        dataStatus: 3,
      });
    },
    resetFlowState (type) {
      makeupdStatus({
        id: this.formData.id,
        dataStatus: type===1?4:5,
      });
    },
    /**
     * @Description: 组装业务数据
     * @Param: 
     * @Author: wangwangwang
     */
    handleBusiness() {
      const { query } = this.$route;
      const data = JSON.parse(query.dataContent);
      let params = "";
      if (this.form.handling === '1') { // 复检
        params = {
          process_success: {
            url: '/icps/system/sign/intelligent/make/createOther',
            data: {
              id: data.id,
              dataTypeId: '3',
              dataType: '复检',
              dataTypeStatus: 1,
            },
            httpMethod: 'post',
          },
          process_failure: ''
        }
      } else { // 异常处理
        params = {
          process_success: {
            url: '/icps/system/sign/dataCollection/consignment/applyException',
            data: {
              consignmentId: data.consignmentId,
              type: 1,
              processMode: this.form.type === '1' ? '退货' : '条件接收',
              acceptableConditings: this.form.acceptableConditings,
              phenomena: this.form.phenomena,
              cause: this.form.cause,
            },
            httpMethod: 'post',
          },
          process_failure: ''
        }
      }
      this.showSendVisible = false;
      this.$refs.flowcontent.handleToFlow(params);
    },
    /**
     * @Description: 
     * @Param: 1为保存，2为最后提交/3 中间提交
     * @Author: wangwangwang
     * @param {*} type
     */
    handleFinish(type, status) {
      const { query } = this.$route;
      const data = JSON.parse(query.dataContent);
      const copyData = JSON.parse(JSON.stringify(this.tableNav));
      copyData.shift();
      if (type === 2 && status * 1 === 2) {
        const params = {
          pid: data.pid,
          consignmentId: data.consignmentId,
          remark: data.remark,
          imgs: data.imgs,
          outcome: data.outcome,
          handling: this.form.handling,
          adjacent: data.adjacent,
          qualified: data.qualified,
          detectionValue: JSON.parse(data.detectionValue)
        }
        saveResul(params);
      }
      addTab.$emit("remove", this.$route.name);
    },
    handleSubmit(type) {
      const self = this;
      const { query } = this.$route;
      if (query.type * 1 === 2 && type === 2 && query.taskType * 1 !== 2) { // 发起流程
        this.showSendVisible = true;
        return
      }
      if (query.type * 1 === 10) { // 强制编辑
        const data = JSON.parse(query.dataContent);
        const copyData = JSON.parse(JSON.stringify(this.tableNav));
        copyData.shift();
        this.$confirm('确定强制修改此流程，修改后业务数据将生效?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          cancelButtonClass: 'bottom_all_two',
          confirmButtonClass: 'bottom_all',
          type: 'warning'
        }).then(() => {
          const params = {
            pid: data.pid,
            consignmentId: data.consignmentId,
            remark: data.remark,
            imgs: data.imgs,
            outcome: data.outcome,
            handling: this.form.handling,
            adjacent: data.adjacent,
            qualified: data.qualified
          }
          saveResul(params).then(res => {
            if (res.code === 1001) {
              const params = {
                dataSource: 'checkflows',
                dataContent: JSON.stringify({ ...self.formData, tableTitle: this.formData.tableTitle, tableDataSource: this.formData.tableDataSource, form: JSON.stringify(self.form), consignmentId: query.consignmentId}), // 业务数据
              }
              self.$refs.flowcontent.saveFlows(type, params, query.type);
            }
          });
        })
        return
      }
      const params = {
        dataSource: 'checkflows',
        dataContent: JSON.stringify({ ...this.formData, tableTitle: query.tableTitle, detectionValue: query.detectionValue, tableDataSource: query.tableDataSource, form: JSON.stringify(this.form), consignmentId: query.consignmentId, }), // 业务数据
      }
      this.$refs.flowcontent.saveFlows(type, params);
    },
    handleFlowChat() {
      this.$refs.flowcontent.showFlowNode();
    },
    handleCancel() {
      this.showSendVisible = false;
    },
    initFlowsData(data) {
      const { query } = this.$route;
      this.formData = data;
      console.log(query)
      this.tableSource = Object.values(JSON.parse(query.tableDataSource)).map(item=>({
                        ...item,
                        options: item.options ? JSON.parse(item.options) : [],
                        resultValue: item.type === 1 ? JSON.parse(item.condition).id : item.resultValue
                    }))
    },
    initFlowsData2() {
      const { query } = this.$route;
      this.formData = JSON.parse(query.dataContent);
      this.tableSource = Object.values(JSON.parse(this.formData.tableDataSource)).map(item=>({
                        ...item,
                        options: item.options ? JSON.parse(item.options) : [],
                        resultValue: item.type === 1 ? JSON.parse(item.condition).id : item.resultValue
                    }));
      this.sendTableSource = JSON.parse(this.formData.tableDataSource);
      this.form = JSON.parse(this.formData.form);
      this.initHandleType(this.formData.rawId, this.formData.contractId);
      this.title = query.taskName;
      this.billCode = query.receiptNumber;
      this.billDate = query.createTime;
      this.applyPerson = query.createUserName;
      this.taskStatus = query.taskStatus;
      let tmp = { ...self.formData, tableTitle: this.formData.tableTitle, tableDataSource: this.formData.tableDataSource, form: JSON.stringify(self.form), consignmentId: query.consignmentId }
      console.log(tmp, this.formData)
    },
    sendCode(code) {
      this.billCode = code;
    },
    initHandleType(rawId, contractId) {
      const params = {
        rawId,
        contractId,
      }
      getOneByPidAndRawId(params).then(res => {
        if (res.code === 1001 && res.data) {
          this.handleList = JSON.parse(res.data.receiveModeId);
        }
      })
    },
  },
  mounted() {
    const { query } = this.$route;
    if (query.type * 1 === 1) { // 发起流程
      this.initFlowsData(query);
      this.initHandleType(query.rawId, query.contractId);
      /**
       * @Description: 判断为哪种流程
       * @Param: dataTypeId  1快检 2批次检测 3复检 4抽检
       * @Author: wangwangwang
       */
      let code = 'OtherCheck';
      if (query.dataTypeId) {
        code = ['', 'FastCheck', 'BatchCheck', 'ReCheckOut', 'SpotCheck'][query.dataTypeId * 1]
      }
      if (query.dataTypeId * 1 === 3) {
        this.form.handling = '2';
      }
      this.$refs.flowcontent.initBaseData(code);
      this.billDate = new Date().Format('yyyy-MM-dd hh:mm:ss');
      this.applyPerson = getUserInfo().userRealName;
      return
    }
    console.log(JSON.parse(query.dataContent))
    this.initFlowsData2();
    if (query.isReadOnly*1===1) {
      this.readOnly = true;
    }
  }
}
</script>
<style lang="scss" scoped>
.flows-details {
  margin-top: 20px;
}
.info {
  padding: 0 20px;
  background: #fff;
  .info-top {
    font-size: $font_size;
    color: #000000;
    @include discen_al;
    justify-content: space-between;
    height: 50px;
    border-bottom: 1px #e1e5ed solid;
    .left {
      @include discen_al;
    }
    .text {
      margin-left: 60px;
    }
  }
}
.nav_title {
  @include discen_al;
  align-items: flex-end;
  > div {
    width: 4px;
    height: 24px;
    background: $bg_color;
    margin-right: 10px;
  }
  i {
    margin-left: 5px;
  }
  color: $bg_color;
  font-size: 20px;
  font-weight: bold;
}
</style>

